var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4408_10226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.75 82C153.75 42.3735 121.627 10.25 82 10.25C42.3735 10.25 10.25 42.3735 10.25 82C10.25 94.9888 13.7014 107.172 19.7371 117.681C16.6316 125.8 13.6987 135.233 11.773 144.659C10.8547 149.154 14.8157 152.958 19.2804 151.901C28.3092 149.763 37.4747 146.799 45.525 143.8C56.2127 150.122 68.6829 153.75 82 153.75C121.627 153.75 153.75 121.627 153.75 82Z",
    fill: "#F8CBA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6667 102.5C66.625 120.722 97.375 120.722 109.333 102.5",
    stroke: "#8F440E",
    strokeWidth: 10.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0833 58.082V64.9154",
    stroke: "#8F440E",
    strokeWidth: 10.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.917 58.082V64.9154",
    stroke: "#8F440E",
    strokeWidth: 10.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.75 82C153.75 42.3735 121.627 10.25 82 10.25C42.3735 10.25 10.25 42.3735 10.25 82C10.25 94.9888 13.7014 107.172 19.7371 117.681C16.6316 125.8 13.6987 135.233 11.773 144.659C10.8547 149.154 14.8157 152.958 19.2804 151.901C28.3092 149.763 37.4747 146.799 45.525 143.8C56.2127 150.122 68.6829 153.75 82 153.75C121.627 153.75 153.75 121.627 153.75 82Z",
    stroke: "#8F440E",
    strokeWidth: 10.25,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4408_10226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 164,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.484fa0e32222b4f946029e32393cc456.svg";
export { ForwardRef as ReactComponent };